import React from "react";
import { Outlet, useLocation } from "react-router-dom";

import SettingsTabs from "../components/Settings/SettingsTabs";
import SettingsSidebar from "../components/Settings/SettingsSidebar";

const Settings = () => {
  const location = useLocation();

  const currentTab = location.pathname.startsWith("/settings/app")
    ? "app"
    : location.pathname.startsWith("/settings/financial")
    ? "financial"
    : location.pathname.startsWith("/settings/website")
    ? "website"
    : location.pathname.startsWith("/settings/system") 
    ? "system"
    : location.pathname.startsWith("/settings/other")
    ? "other"
    : "general";

  return (
    <div className="container-fluid p-4">
      <h5 className="mb-3">Settings</h5>

      {/* TABS */}
      <SettingsTabs />

      <div className="row mt-3">
        {/* SIDEBAR */}
        <div className="col-md-3">
          <SettingsSidebar type={currentTab} />
        </div>

        {/* CONTENT */}
        <div className="col-md-9">
        
            <Outlet />
        
        </div>
      </div>
    </div>
  );
};

export default Settings;